<template>
  <div class="background-container">
    <div class="text-content">
      <Loading :loading="loading"></Loading>
      <SsoError v-if="error" :message="error"></SsoError>
      <div v-if="this.$route.query.sso && !studentInfoArea && !teacherInfoArea && !teacherClassArea && !error" style="text-align: center;">
        <p style="font-size: 20px; font-weight: bold;">Lütfen bekleyiniz, ilgili platforma yönlendiriliyorsunuz.</p>
        <p>&nbsp;</p>
        <p style="font-size: 20px; font-weight: bold;">Please wait, you are being redirected to the relevant platform.</p>
      </div>
      <div v-if="studentInfoArea">
        <p style="font-weight: bold;">Değerli Öğrencimiz,</p>
        <p>Raz-Plus'a hoş geldiniz. Giriş talebiniz işleme alınmıştır ve hesabınız, en geç 24 saat içerisinde aktif hale gelecektir. Bu süre zarfında beklediğiniz için teşekkür ederiz.</p>
        <p>Size destek olabileceğimiz her türlü konuda, 0850 550 50 90 numaralı telefonumuzdan ya da diğer destek kanallarımızdan bize ulaşabilirsiniz.</p>
        <p>&nbsp;</p>
        <p style="font-weight: bold;">Dear Student,</p>
        <p>Welcome to Raz-Plus. Your login request has been processed, and your account will be activated within 24 hours. We appreciate your patience during this time.</p>
        <p>If you need any assistance, please feel free to contact us at 0850 550 50 90 or through our other support channels</p>
      </div>
      <div v-if="teacherInfoArea">
        <p style="font-weight: bold;">Değerli Öğretmenimiz,</p>
        <p>Raz-Plus'a hoş geldiniz. Giriş talebiniz işleme alınmıştır ve hesabınız, en geç 24 saat içerisinde aktif hale gelecektir. Bu süre zarfında beklediğiniz için teşekkür ederiz.</p>
        <p>Size destek olabileceğimiz her türlü konuda, 0850 550 50 90 numaralı telefonumuzdan ya da diğer destek kanallarımızdan bize ulaşabilirsiniz.</p>
        <p>&nbsp;</p>
        <p style="font-weight: bold;">Dear Teacher,</p>
        <p>Welcome to Raz-Plus. Your login request has been processed, and your account will be activated within 24 hours. We appreciate your patience during this time.</p>
        <p>If you need any assistance, please feel free to contact us at 0850 550 50 90 or through our other support channels</p>
      </div>
      <div v-if="teacherClassArea" style="width: 600px;">
        <p style="font-weight: bold;">Dear {{ this.uesLmsUserData.user_name }},</p>
        <p>&nbsp;</p>
        <p><strong>Please select the class you wish to enter:</strong><br />(Please make sure your browser does not block pop-ups.)</p>
        <p>&nbsp;</p>
        <div v-for="(class_name, class_id, key) in uesLmsUserData.class_name" :key="key" style="display:inline-flex;">
          <div style="background-color: #118019; margin: 6px; display: inline-block; font-weight: bold;">
            <div @click="getRazToken(class_id, 'teacher')" style="padding: 10px 20px; color: #fff; cursor: pointer;">
              {{ class_name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import SsoError from "@/components/SsoError";
import _ from 'lodash';
import axios from "axios";
import CryptoJS from "crypto-js";
import { isJwtSso } from "@/utils/ssoJwt";

export default {
  name: "RazPlus",
  components: {
    Loading,
    SsoError
  },
  data() {
    return {
      loading: false,
      error: null,
      secretKey: 'DZYQSbQQKmruR4ZYOLD%s7163BZjoyViqF7gWy.A6Gd9JAyXCL!eNGsrEJVcPUe',
      // ueslms_service_baseurl: 'http://localhost:4000', // local
      ueslms_service_baseurl: 'https://ueslms-service-api.ey.r.appspot.com', // prod
      userData: null,
      ssoJwt: null,
      user_id: null,
      user_role: null,
      token: null,
      app_code: 'ues_learningaz_sso',
      studentInfoArea: false,
      teacherInfoArea: false,
      teacherClassArea: false,
      uesLmsUserData: [],
      teacherClassCount: 0,
    }
  },
  beforeMount() {
    const query = this.$route.query;
    if (query.sso) {
      this.loading = true

      // Akbim altyapılı bazı okullar AES yerine kendi JWT'lerini gönderiyor — bu durumda
      // AES çözmeyi hiç denemiyoruz (denersek atob() "." karakteri yüzünden hata verir),
      // ham değeri sso_jwt olarak backend'e yolluyoruz; okul/kampüs eşleştirmesi ve çözme
      // orada yapılıyor (bkz. AkbimJwtSsoService).
      if (isJwtSso(query.sso)) {
        this.ssoJwt = query.sso;
        this.ueslmsCheckUser();
        return;
      }

      // gelen data çözülüyor
      try {
        const decode = decodeURIComponent(atob(query.sso));
        const bytes = CryptoJS.AES.decrypt(decode, this.secretKey).toString(CryptoJS.enc.Utf8);
        this.userData = JSON.parse(bytes);
      } catch (e) {
        this.fail('Giriş bilgileri okunamadı. Lütfen kurumunuzla iletişime geçin.');
        return;
      }
      this.ueslmsCheckUser();
    } else {
      location.href = "https://service.ueslms.com";
    }
  },
  methods: {
    fail(message) {
      this.loading = false;
      this.error = message;
      console.log('RazPlus SSO:', message);
    },

    ueslmsCheckUser() {
      const body = this.ssoJwt ? {sso_jwt: this.ssoJwt} : {user: this.userData};
      axios.post('https://www.ueslms.com/api/v2/raz-plus/user/check', body)
      // axios.post('https://ueslms.test/api/v2/raz-plus/user/check', body)
          .then(response => {
            if (response.data.success) {

              this.uesLmsUserData = response.data.user
              this.user_id = this.uesLmsUserData.user_id;
              this.user_role = this.uesLmsUserData.role_type;

              // console.log("Minutes değeri:", this.uesLmsUserData.minutes);
              // console.log("Kullanıcı rolü:", this.user_role);

              // Tüm info alanlarını önce false yapıyoruz
              this.studentInfoArea = false;
              this.teacherInfoArea = false;
              this.teacherClassArea = false;

              if (this.uesLmsUserData.minutes < 1080) {
                // Süre 1080 dakikadan KÜÇÜK ise, role göre bilgi alanları gösteriliyor
                this.loading = false;

                if (this.user_role === 'student') {
                  this.studentInfoArea = true;
                } else if (this.user_role === 'teacher') {
                  this.teacherInfoArea = true;
                  this.teacherClassArea = false;
                }
              } else {
                // Süre 1080 dakikadan BÜYÜK veya EŞİT ise, role göre işlem yapılıyor
                if (this.user_role === 'student') {
                  this.getRazToken(this.user_id, this.user_role);
                } else if (this.user_role === 'teacher') {
                  this.checkTeacherClassCount();
                }
              }

            } else if (response.data.message) {
              this.fail(response.data.message)
            } else {
              // alert('create')
              this.ueslmsCreate()
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    ueslmsCreate() {
      const body = this.ssoJwt ? {sso_jwt: this.ssoJwt} : this.userData;
      axios.post('https://www.ueslms.com/api/v2/raz-plus/user/create', body)
      // axios.post('https://ueslms.test/api/v2/raz-plus/user/create', body)
          .then(response => {
            if (response.data.success) {
              // Kayıt yeni oluşmuşsa beklemesi gerekiyor.
              this.loading = false;
              this.studentInfoArea = true;
              // this.user_id = response.data.user.user_id;
              // this.user_role = response.data.user.type;
              // this.getRazToken()
            } else {
              this.fail(response.data.message || 'Kullanıcı oluşturulamadı. Lütfen tekrar deneyin.')
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    checkTeacherClassCount() {
      let classCount = _.size(this.uesLmsUserData.class_name)
      // console.log('SINIF SAYISI', classCount)
      this.teacherClassCount = classCount;

      // minutes değeri 1080'den büyük olduğunda burada olduğumuza göre
      // tek sınıf olsa da çoklu sınıf olsa da öğretmene liste göstermeden
      // direkt işlem yapmalıyız
      if (classCount === 1) {
        // tek sınıf varsa direkt yönlendirme yapılabilir
        let classId = Object.keys(this.uesLmsUserData.class_name)[0]
        this.getRazToken(classId, 'teacher')
      } else {
        // Birden fazla sınıf varsa, minutes > 1080 olduğu için direkt liste gösteriyoruz
        // fakat teacherInfoArea = false yaparak infoArea görünmesini engelliyoruz
        this.loading = false
        this.teacherInfoArea = false;
        this.teacherClassArea = true;
      }
    },

    async getRazToken(id, role) {
      this.loading = true;
      let url = `${this.ueslms_service_baseurl}/sso/raz-plus/token`;
      let data = {
        user_id: '',
        user_role: '',
      }
      if (role === 'student') {
        data.user_id = id;
        data.user_role = 'student';
      } else {
        const keys = Object.keys(this.uesLmsUserData.virtuals);
        const values = Object.values(this.uesLmsUserData.virtuals);
        const index = keys.indexOf(id);
        data.user_id = values[index];
        data.user_role = 'teacher';
      }
      // console.log('ID', id)
      // console.log('DATA', data)
      await axios.post(url, data)
          .then(response => {
            this.token = response.data.token;
            // console.log('TOKEN', this.token);
            if (role === 'student') {
              this.goRazPlus()
            } else {
              this.goRazPlusTeacher()
            }
          })
          .catch(response => {
            console.log('ERR', response);
            this.loading = false;
          })
    },

    goRazPlus() {
      this.loading = false;
      const url = "https://www.kidsa-z.com/main/LoginExternal/?app=" + this.app_code + "&token=" + this.token;
      location.href = url;
    },

    goRazPlusTeacher() {
      const url = "https://www.kidsa-z.com/main/LoginExternal/?app=" + this.app_code + "&token=" + this.token;
      // öğretmen sınıf sayısı 1 ise direkt yönlendirme yapıyoruz
      if (this.teacherClassCount === 1) {
        location.href = url;
      } else {
        this.loading = false;
        // birden fazla sınıf varsa yeni sekmede açıyoruz
        window.open(url, '_blank');
      }
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body,
html {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Arial, sans-serif;
}

.background-container {
  margin: 0 auto;
  position: relative;
  width: 1200px;
  min-height: 675px;
  background-image: url('/assets/images/bg-raz-plus.png');
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: start;
}

.text-content {
  width: 700px;
  margin-top: 175px;
  text-align: left;
  color: white;
}

p {
  font-size: 16px;
  line-height: 26px;
}
</style>
